var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { DataChunkDataType, } from '../../proto/ai/inworld/packets/packets.pb';
import { AudioSessionState, TtsPlaybackAction, } from '../common/data_structures';
import { InworldPlayer } from '../components/sound/inworld_player';
import { InworldRecorder } from '../components/sound/inworld_recorder';
var InworldConnectionService = /** @class */ (function () {
    function InworldConnectionService(props) {
        var _this = this;
        this.connection = props.connection;
        this.grpcAudioPlayer = props.grpcAudioPlayer;
        this.player = new InworldPlayer({
            grpcAudioPlayer: this.grpcAudioPlayer,
        });
        this.recorder = new InworldRecorder({
            listener: function (base64AudioChunk) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(!this.connection.isActive() &&
                                this.connection.isAutoReconnected() &&
                                this.connection.getAudioSessionAction() !== AudioSessionState.START)) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.sendAudioSessionStart()];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            this.sendAudio(base64AudioChunk);
                            return [2 /*return*/];
                    }
                });
            }); },
            grpcAudioPlayer: this.grpcAudioPlayer,
            grpcAudioRecorder: props.grpcAudioRecorder,
            webRtcLoopbackBiDiSession: props.webRtcLoopbackBiDiSession,
        });
    }
    InworldConnectionService.prototype.getSessionState = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.connection.getSessionState()];
            });
        });
    };
    InworldConnectionService.prototype.open = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.connection.openManually()];
            });
        });
    };
    InworldConnectionService.prototype.close = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.connection.close();
                        this.recorder.stop();
                        return [4 /*yield*/, this.player.stop()];
                    case 1:
                        _a.sent();
                        this.player.clear();
                        return [2 /*return*/];
                }
            });
        });
    };
    InworldConnectionService.prototype.isActive = function () {
        return this.connection.isActive();
    };
    InworldConnectionService.prototype.getCharacters = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.connection.getCharactersList()];
            });
        });
    };
    InworldConnectionService.prototype.getCurrentCharacter = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.connection.getCharactersList()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this.connection.getEventFactory().getCurrentCharacter()];
                }
            });
        });
    };
    InworldConnectionService.prototype.getHistory = function () {
        return this.connection.getHistory();
    };
    InworldConnectionService.prototype.clearHistory = function () {
        return this.connection.clearHistory();
    };
    InworldConnectionService.prototype.getTranscript = function () {
        return this.connection.getTranscript();
    };
    InworldConnectionService.prototype.setCurrentCharacter = function (character) {
        return this.connection.getEventFactory().setCurrentCharacter(character);
    };
    InworldConnectionService.prototype.sendText = function (text) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.connection.send(function () {
                        return _this.connection.getEventFactory().text(text);
                    })];
            });
        });
    };
    InworldConnectionService.prototype.sendAudio = function (chunk) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.connection.send(function () {
                        return _this.connection
                            .getEventFactory()
                            .dataChunk(chunk, DataChunkDataType.AUDIO);
                    })];
            });
        });
    };
    InworldConnectionService.prototype.sendTrigger = function (name, parameters) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.connection.send(function () {
                        return _this.connection.getEventFactory().trigger(name, parameters);
                    })];
            });
        });
    };
    InworldConnectionService.prototype.sendAudioSessionStart = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (this.connection.getAudioSessionAction() === AudioSessionState.START) {
                    throw Error('Audio session is already started');
                }
                this.connection.setAudioSessionAction(AudioSessionState.START);
                return [2 /*return*/, this.connection.send(function () {
                        return _this.connection.getEventFactory().audioSessionStart();
                    })];
            });
        });
    };
    InworldConnectionService.prototype.sendAudioSessionEnd = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (this.connection.getAudioSessionAction() !== AudioSessionState.START) {
                    throw Error('Audio session cannot be ended because it has not been started');
                }
                this.connection.setAudioSessionAction(AudioSessionState.END);
                return [2 /*return*/, this.connection.send(function () {
                        return _this.connection.getEventFactory().audioSessionEnd();
                    })];
            });
        });
    };
    InworldConnectionService.prototype.sendTTSPlaybackStart = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.connection.send(function () {
                        return _this.connection.getEventFactory().ttsPlaybackStart();
                    })];
            });
        });
    };
    InworldConnectionService.prototype.sendTTSPlaybackEnd = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.connection.send(function () {
                        return _this.connection.getEventFactory().ttsPlaybackEnd();
                    })];
            });
        });
    };
    InworldConnectionService.prototype.sendTTSPlaybackMute = function (isMuted) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.connection.setTtsPlaybackAction(isMuted ? TtsPlaybackAction.MUTE : TtsPlaybackAction.UNMUTE);
                return [2 /*return*/, this.connection.send(function () {
                        return _this.connection.getEventFactory().ttsPlaybackMute(isMuted);
                    })];
            });
        });
    };
    InworldConnectionService.prototype.sendCancelResponse = function (cancelResponses) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.connection.send(function () {
                        return _this.connection.getEventFactory().cancelResponse(cancelResponses);
                    })];
            });
        });
    };
    InworldConnectionService.prototype.sendCustomPacket = function (getPacket) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.connection.send(function () { return getPacket(); })];
            });
        });
    };
    InworldConnectionService.prototype.interrupt = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.connection.interrupt()];
            });
        });
    };
    InworldConnectionService.prototype.baseProtoPacket = function (props) {
        return this.connection.getEventFactory().baseProtoPacket(props);
    };
    return InworldConnectionService;
}());
export { InworldConnectionService };
